(function () {
  const endpoint = "/apps/portal/data";
  let dataPromise = null;

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function sanitizeCustomerName(value, fallback) {
    const cleaned = String(value == null ? "" : value).trim();
    if (!cleaned || cleaned.includes("{{") || cleaned.includes("{%")) {
      return fallback || "Collector";
    }
    return cleaned;
  }

  function formatDateTime(value) {
    if (!value) return "Date TBA";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "Date TBA";
    return date.toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  }

  function formatMoney(value) {
    const amount = Number(value || 0);
    if (!Number.isFinite(amount)) return null;
    return amount.toLocaleString(undefined, {
      style: "currency",
      currency: "USD",
    });
  }

  function formatCountLabel(count, singular, plural) {
    const safeCount = Number.isFinite(Number(count)) ? Number(count) : 0;
    return `${safeCount} ${safeCount === 1 ? singular : plural}`;
  }

  async function fetchData() {
    if (!dataPromise) {
      dataPromise = fetch(endpoint, {
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
        },
      }).then(async (response) => {
        if (!response.ok) {
          throw new Error(`Request failed with ${response.status}`);
        }
        return response.json();
      });
    }

    return dataPromise;
  }

  function renderLinkButtons(links) {
    return `
      <div class="darkstone-app-links">
        <a class="darkstone-app-button darkstone-app-button--primary" href="${escapeHtml(links.pullList)}">Pull List Portal</a>
        <a class="darkstone-app-button" href="${escapeHtml(links.guild)}">Guild Ledger</a>
        <a class="darkstone-app-button" href="${escapeHtml(links.events)}">Events & Tickets</a>
      </div>
    `;
  }

  function renderSummaryCards(data) {
    const loyalty = data.loyalty || {};
    const pullList = data.pullList || {};
    const tickets = data.eventTickets || {};

    return `
      <div class="darkstone-app-grid darkstone-app-grid--summary">
        <article class="darkstone-app-card">
          <div class="darkstone-app-card__body">
            <div class="darkstone-app-card__eyebrow">Guild Status</div>
            <h3 class="darkstone-app-card__title">${escapeHtml(loyalty.enrolled ? loyalty.tierName || "Guild Member" : "Adventurers Guild")}</h3>
            <div class="darkstone-app-card__metric">${escapeHtml(String(loyalty.points || 0))}</div>
            <p class="darkstone-app-card__meta">Guild Coins available${loyalty.nextTierName ? ` | Next rank: ${escapeHtml(loyalty.nextTierName)}` : ""}</p>
            ${loyalty.enrolled
              ? `<div class="darkstone-app-chip-row">
                  <span class="darkstone-app-chip darkstone-app-chip--gold">${escapeHtml(loyalty.barcode || "")}</span>
                  <span class="darkstone-app-chip darkstone-app-chip--purple">${escapeHtml(String(loyalty.nextTierProgressPercent || 100))}% to next rank</span>
                </div>`
              : `<p class="darkstone-app-card__copy">Join the Guild to earn coins, unlock ranks, and redeem rewards online and in store.</p>`
            }
          </div>
        </article>

        <article class="darkstone-app-card">
          <div class="darkstone-app-card__body">
            <div class="darkstone-app-card__eyebrow">Pull List</div>
            <h3 class="darkstone-app-card__title">Subscriptions & holds</h3>
            <div class="darkstone-app-card__metric">${escapeHtml(String(pullList.activeCount || 0))}</div>
            <p class="darkstone-app-card__meta">Active subscriptions${pullList.historyCount ? ` | ${escapeHtml(String(pullList.historyCount))} recent history` : ""}</p>
            <div class="darkstone-app-chip-row">
              <span class="darkstone-app-chip">${escapeHtml(String(pullList.reservableCount || 0))} upcoming books open</span>
              ${Array.isArray(pullList.activeItems) && pullList.activeItems[0]
                ? `<span class="darkstone-app-chip darkstone-app-chip--purple">${escapeHtml(pullList.activeItems[0].title)}</span>`
                : ""
              }
            </div>
          </div>
        </article>

        <article class="darkstone-app-card">
          <div class="darkstone-app-card__body">
            <div class="darkstone-app-card__eyebrow">Event Tickets</div>
            <h3 class="darkstone-app-card__title">Live tickets & history</h3>
            <div class="darkstone-app-card__metric">${escapeHtml(String(tickets.upcomingCount || 0))}</div>
            <p class="darkstone-app-card__meta">Upcoming tickets${tickets.pastCount ? ` | ${escapeHtml(String(tickets.pastCount))} in history` : ""}</p>
            <div class="darkstone-app-chip-row">
              <span class="darkstone-app-chip">${escapeHtml(String(tickets.pastCount || 0))} past tickets</span>
              ${Array.isArray(tickets.upcoming) && tickets.upcoming[0]
                ? `<span class="darkstone-app-chip darkstone-app-chip--gold">${escapeHtml(tickets.upcoming[0].statusLabel || tickets.upcoming[0].status || "Ready")}</span>`
                : ""
              }
            </div>
          </div>
        </article>
      </div>
    `;
  }

  function renderTicket(ticket) {
    const chips = [];
    if (ticket.statusLabel) chips.push(`<span class="darkstone-app-chip darkstone-app-chip--gold">${escapeHtml(ticket.statusLabel)}</span>`);
    if (ticket.ticketCode) chips.push(`<span class="darkstone-app-chip">${escapeHtml(ticket.ticketCode)}</span>`);

    return `
      <article class="darkstone-app-ticket">
        <a class="darkstone-app-ticket__qr" href="${escapeHtml(ticket.viewUrl)}">
          <img src="${escapeHtml(ticket.qrUrl)}" alt="${escapeHtml(ticket.title)} QR code">
        </a>
        <div>
          <h4 class="darkstone-app-ticket__title">${escapeHtml(ticket.title)}</h4>
          <p class="darkstone-app-ticket__meta">
            <strong>${escapeHtml(formatDateTime(ticket.startsAt))}</strong>
            ${ticket.location ? ` | ${escapeHtml(ticket.location)}` : ""}
          </p>
          <div class="darkstone-app-chip-row">${chips.join("")}</div>
          <div class="darkstone-app-links">
            <a class="darkstone-app-button" href="${escapeHtml(ticket.viewUrl)}">Open ticket</a>
          </div>
        </div>
      </article>
    `;
  }

  function renderHistoryTicket(ticket) {
    const chips = [];
    if (ticket.statusLabel) chips.push(`<span class="darkstone-app-chip darkstone-app-chip--gold">${escapeHtml(ticket.statusLabel)}</span>`);
    if (ticket.checkedInAt) chips.push(`<span class="darkstone-app-chip">Scanned ${escapeHtml(formatDateTime(ticket.checkedInAt))}</span>`);

    return `
      <article class="darkstone-app-ticket darkstone-app-ticket--history">
        <div>
          <h4 class="darkstone-app-ticket__title">${escapeHtml(ticket.title)}</h4>
          <p class="darkstone-app-ticket__meta">
            <strong>${escapeHtml(formatDateTime(ticket.startsAt))}</strong>
            ${ticket.location ? ` | ${escapeHtml(ticket.location)}` : ""}
          </p>
          <div class="darkstone-app-chip-row">${chips.join("")}</div>
          <div class="darkstone-app-links">
            <a class="darkstone-app-button" href="${escapeHtml(ticket.viewUrl)}">Open ticket record</a>
          </div>
        </div>
      </article>
    `;
  }

  function renderEvent(event) {
    const price = formatMoney(event.ticketPrice);
    const compareAt = formatMoney(event.compareAtPrice);
    const image = event.imageUrl
      ? `<div class="darkstone-app-event__image"><img src="${escapeHtml(event.imageUrl)}" alt="${escapeHtml(event.imageAlt || event.title)}"></div>`
      : `<div class="darkstone-app-event__image"><div class="darkstone-app-event__image-fallback">${escapeHtml(event.title)}</div></div>`;

    return `
      <article class="darkstone-app-card darkstone-app-event">
        ${image}
        <div class="darkstone-app-card__body">
          <p class="darkstone-app-kicker">Upcoming Event</p>
          <h3 class="darkstone-app-event__title">${escapeHtml(event.title)}</h3>
          <p class="darkstone-app-event__meta">
            <strong>${escapeHtml(formatDateTime(event.startsAt))}</strong>
            ${event.location ? ` | ${escapeHtml(event.location)}` : ""}
          </p>
          ${event.description ? `<p class="darkstone-app-card__copy">${escapeHtml(event.description)}</p>` : ""}
          <div class="darkstone-app-chip-row">
            ${price ? `<span class="darkstone-app-chip darkstone-app-chip--gold">${escapeHtml(price)}</span>` : ""}
            ${compareAt && compareAt !== price ? `<span class="darkstone-app-chip">${escapeHtml(compareAt)} compare at</span>` : ""}
          </div>
          <div class="darkstone-app-links">
            ${event.productUrl
              ? `<a class="darkstone-app-button darkstone-app-button--primary" href="${escapeHtml(event.productUrl)}">Get tickets</a>`
              : `<a class="darkstone-app-button" href="/pages/events">View event info</a>`
            }
          </div>
        </div>
      </article>
    `;
  }

  function renderCollapsibleEventSection(title, countLabel, bodyHtml) {
    return `
      <details class="darkstone-app-collapsible">
        <summary class="darkstone-app-collapsible__summary">
          <span class="darkstone-app-collapsible__summary-copy">
            <h3 class="darkstone-app-section__heading">${escapeHtml(title)}</h3>
            <span class="darkstone-app-chip darkstone-app-collapsible__count">${escapeHtml(countLabel)}</span>
          </span>
          <span class="darkstone-app-collapsible__toggle">
            <span class="darkstone-app-collapsible__toggle-show">View</span>
            <span class="darkstone-app-collapsible__toggle-hide">Hide</span>
          </span>
        </summary>
        <div class="darkstone-app-collapsible__body">
          ${bodyHtml}
        </div>
      </details>
    `;
  }

  function renderAccountMode(root, data) {
    const customerName = sanitizeCustomerName(data.customer?.firstName, "Collector");
    const upcomingTickets = Array.isArray(data.eventTickets?.upcoming) ? data.eventTickets.upcoming : [];
    const pastTickets = Array.isArray(data.eventTickets?.past) ? data.eventTickets.past : [];
    const upcomingEvents = Array.isArray(data.upcomingEvents) ? data.upcomingEvents.slice(0, 3) : [];

    root.innerHTML = `
      <div class="darkstone-app-card">
        <div class="darkstone-app-card__body">
          <div class="darkstone-app-card__eyebrow">Collector Hub</div>
          <h2 class="darkstone-app-card__title">Welcome back, ${escapeHtml(customerName)}</h2>
          <p class="darkstone-app-card__copy">Your guild progress, pull list, and event tickets now live right inside your storefront account.</p>
          ${renderLinkButtons(data.links)}
        </div>
      </div>

      <div class="darkstone-app-section">
        ${renderSummaryCards(data)}
      </div>

      <div class="darkstone-app-section">
        <h3 class="darkstone-app-section__heading">Your next tickets</h3>
        ${upcomingTickets.length
          ? `<div class="darkstone-app-stack">${upcomingTickets.map(renderTicket).join("")}</div>`
          : `<div class="darkstone-app-empty">Your next event ticket will appear here with a scannable QR code and quick access link.</div>`
        }
      </div>

      <div class="darkstone-app-section">
        <h3 class="darkstone-app-section__heading">Ticket history</h3>
        ${pastTickets.length
          ? `<div class="darkstone-app-stack">${pastTickets.map(renderHistoryTicket).join("")}</div>`
          : `<div class="darkstone-app-empty">Checked-in and past event tickets will stay visible here as your history builds.</div>`
        }
      </div>

      <div class="darkstone-app-section">
        <h3 class="darkstone-app-section__heading">Upcoming Darkstone events</h3>
        ${upcomingEvents.length
          ? `<div class="darkstone-app-grid darkstone-app-grid--events">${upcomingEvents.map(renderEvent).join("")}</div>`
          : `<div class="darkstone-app-empty">No upcoming events are live on the storefront right now.</div>`
        }
      </div>
    `;
  }

  function renderEventsMode(root, data) {
    const upcomingTickets = Array.isArray(data.eventTickets?.upcoming) ? data.eventTickets.upcoming : [];
    const pastTickets = Array.isArray(data.eventTickets?.past) ? data.eventTickets.past.slice(0, 3) : [];
    const upcomingEvents = Array.isArray(data.upcomingEvents) ? data.upcomingEvents : [];
    const upcomingTicketsBody = upcomingTickets.length
      ? `<div class="darkstone-app-stack">${upcomingTickets.map(renderTicket).join("")}</div>`
      : `<div class="darkstone-app-empty">You do not have any active event tickets yet. Grab one from the upcoming events below.</div>`;
    const pastTicketsBody = pastTickets.length
      ? `<div class="darkstone-app-stack">${pastTickets.map(renderHistoryTicket).join("")}</div>`
      : `<div class="darkstone-app-empty">Your checked-in and past tickets will appear here automatically.</div>`;

    root.innerHTML = `
      ${data.authenticated
        ? ""
        : `<div class="darkstone-app-login-note">Sign in to your store account to see purchased tickets and quick entry codes here.</div>`
      }

      ${data.authenticated
        ? `<div class="darkstone-app-section">
            ${renderCollapsibleEventSection(
              "Your event tickets",
              formatCountLabel(upcomingTickets.length, "active ticket", "active tickets"),
              upcomingTicketsBody
            )}
          </div>`
        : ""
      }

      ${data.authenticated
        ? `<div class="darkstone-app-section">
            ${renderCollapsibleEventSection(
              "Recent ticket history",
              formatCountLabel(pastTickets.length, "recent ticket", "recent tickets"),
              pastTicketsBody
            )}
          </div>`
        : ""
      }

      <div class="darkstone-app-section">
        <h3 class="darkstone-app-section__heading">Upcoming events</h3>
        ${upcomingEvents.length
          ? `<div class="darkstone-app-grid darkstone-app-grid--events">${upcomingEvents.map(renderEvent).join("")}</div>`
          : `<div class="darkstone-app-empty">No upcoming events are currently published.</div>`
        }
      </div>

      <div class="darkstone-app-card" style="margin-top:1rem;">
        <div class="darkstone-app-card__body">
          <div class="darkstone-app-card__eyebrow">Quick Access</div>
          <h3 class="darkstone-app-card__title">Need the rest of your Darkstone tools?</h3>
          <p class="darkstone-app-card__copy">Manage subscriptions, open your Guild Ledger, or jump back into your account from here.</p>
          ${renderLinkButtons(data.links)}
        </div>
      </div>
    `;
  }

  function renderError(root) {
    root.innerHTML = `
      <div class="darkstone-app-error">
        We couldn't load your Darkstone app data right now. Please refresh the page in a moment.
      </div>
    `;
  }

  async function mount(root) {
    root.innerHTML = '<div class="darkstone-app-loading">Loading Darkstone data...</div>';

    try {
      const data = await fetchData();
      const mode = root.getAttribute("data-mode") || "account";

      if (mode === "events") {
        renderEventsMode(root, data);
        return;
      }

      renderAccountMode(root, data);
    } catch (error) {
      console.error("[Darkstone App Hub] Failed to load theme integration data:", error);
      renderError(root);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-darkstone-app-hub]").forEach(function (root) {
      mount(root);
    });
  });

  window.DarkstoneAppHub = {
    refresh: function () {
      dataPromise = null;
      document.querySelectorAll("[data-darkstone-app-hub]").forEach(function (root) {
        mount(root);
      });
    },
  };
})();
